"use strict";

require("core-js/modules/es6.string.fixed");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var util_1 = require("../util");

var GraphQLAssetAccessor =
/** @class */
function () {
  function GraphQLAssetAccessor(base) {
    this.base = base || {};
  }

  GraphQLAssetAccessor.prototype.hasLocalFileChildImage = function () {
    return this.base.localFile && this.base.localFile.childImageSharp;
  };

  GraphQLAssetAccessor.prototype.isContentfulAssetFragmentDownloadLocalFluid = function () {
    return this.hasLocalFileChildImage() && this.base.localFile.childImageSharp.fluid;
  };

  GraphQLAssetAccessor.prototype.isContentfulAssetFragmentDownloadLocalFixed = function () {
    return this.hasLocalFileChildImage() && this.base.localFile.childImageSharp.fixed;
  };

  GraphQLAssetAccessor.prototype.hasBaseFileUrl = function () {
    return this.base.file && this.base.file.url;
  };

  GraphQLAssetAccessor.prototype.hasBaseFileContentType = function () {
    return this.base.file && this.base.file.contentType;
  };

  GraphQLAssetAccessor.prototype.url = function (defaultValue) {
    if (this.hasBaseFileUrl()) {
      return this.base.file.url;
    }

    return defaultValue;
  };

  GraphQLAssetAccessor.prototype.fluid = function (opts) {
    if (this.isContentfulAssetFragmentDownloadLocalFluid()) {
      return this.base.localFile.childImageSharp.fluid;
    }

    if (!!this.base.fluid) {
      return this.base.fluid;
    }

    if (this.hasBaseFileUrl()) {
      return {
        src: this.base.file.url
      };
    }

    return util_1.createFallbackFluidImageObject(opts && opts.fallbackImage);
  };

  GraphQLAssetAccessor.prototype.fixed = function (opts) {
    if (this.isContentfulAssetFragmentDownloadLocalFixed()) {
      return this.base.localFile.childImageSharp.fixed;
    }

    if (!!this.base.fixed) {
      return this.base.fixed;
    }

    if (this.hasBaseFileUrl()) {
      return {
        src: this.base.file.url
      };
    }

    return util_1.createFallbackFixedImageObject(opts && opts.fallbackImage);
  };

  GraphQLAssetAccessor.prototype.title = function () {
    if (this.base.title) {
      return this.base.title;
    }

    return undefined;
  };

  GraphQLAssetAccessor.prototype.type = function () {
    if (this.hasBaseFileContentType()) {
      return util_1.getAssetTypeFromMimeType(this.base.file.contentType);
    }

    return undefined;
  };

  return GraphQLAssetAccessor;
}();

exports.GraphQLAssetAccessor = GraphQLAssetAccessor;